import React from 'react'
import useReveal, { revealClass } from '../hooks/useReveal'

const Incoherencia = ({id, title, phg, links}) => {
  const hasLinks = links && links.length > 0
  const [ref, visible] = useReveal()

  return (
    <div ref={ref} className={`flex flex-col gap-4 items-center ${revealClass(visible)}`} id={id}>
        <div className='flex flex-row w-full items-center gap-10'>
            <hr className='w-1/2' />
            <img src="/svg/comillas.svg" alt="Comillas" />
            <hr className='w-1/2' />
        </div>
        <h4>{title}</h4>
        {/* el degradado difumina el final del texto: sirve para los poemas, pero
            volvería ilegibles los textos largos que listan publicaciones */}
        <p className={hasLinks
          ? ''
          : 'text-transparent bg-clip-text bg-gradient-to-b from-secondary-500/100 to-secondary-500/0'}>{phg}</p>

        {hasLinks &&
          <ul className='grid w-full grid-cols-1 lg:grid-cols-2 gap-x-12 gap-y-3 pt-4'>
            {links.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='underline underline-offset-4 decoration-secondary-500/40 hover:decoration-secondary-500'
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        }
    </div>
  )
}

export default Incoherencia
